import { render, staticRenderFns } from "./RgObjectHistoryPlayer.vue?vue&type=template&id=64943bc3&scoped=true&"
import script from "./RgObjectHistoryPlayer.vue?vue&type=script&lang=js&"
export * from "./RgObjectHistoryPlayer.vue?vue&type=script&lang=js&"
import style0 from "./RgObjectHistoryPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64943bc3",
  null
  
)

export default component.exports